import { CommonResponse } from "@gtpl/shared-models/masters";

export class ProductCountDto {
  constructor(
    public productCountId: number,
    public productId: number,
    public productName: string,
    public productCount: string,
    public createdUser: string,
    public createdAt: Date,
    public updatedUser: string,
    public versionFlag: number,
    public updatedAt: Date
  ) {}
}

export class ProductCountRequestDto {
  constructor(
    public productCountReq: ProductCountDto[],
    public createdUser: string
  ) {}
}

export class ProductCountResponseModel extends CommonResponse {
  data: ProductCountDto;
}

export class AllProductCountResponseModel extends CommonResponse {
  data: ProductCountDto[];
}
